<p-breadcrumb
  [model]="[{ label: 'Modelos', routerLink: ['/models'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Modelos</h5>
      <p>Gerencie os modelos de produtos</p>
    </div>
    <p-button label="Novo Modelo" routerLink="/models/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="models()"
  [lazy]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="nameFilter"
          class="block"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome"
          fluid
        />
      </div>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="descriptionFilter"
          class="block"
          [(ngModel)]="descriptionFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Descrição"
          fluid
        />
      </div>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th>Imagem</th>
      <th>Nome</th>
      <th>Marca</th>
      <th>Categoria</th>
      <th>Descrição</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td style="min-width: 5rem">
        @if (item.imageUrl) {
          <img [src]="item.imageUrl" alt="modelImage" class="w-10" />
        }
      </td>
      <td>{{ item.name }}</td>
      <td>{{ item.brandName }}</td>
      <td>{{ item.categoryName }}</td>
      <td>{{ item.description || "-" }}</td>
      <td>
        <div
          class="flex justify-start"
          (click)="requestUpdateStatus(item, $event)"
        >
          <div class="flex items-center gap-2">
            <p-toggleswitch
              [ngModel]="item.isActive"
              [style.pointer-events]="'none'"
            ></p-toggleswitch>
            {{ item.isActive ? "Ativo" : "Inativo" }}
          </div>
        </div>
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/models/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast />
<p-confirmdialog />
